export default "__VITE_ASSET__Cn393lKh__"